function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.3898 0.25C7.50891 0.25 0.306456 7.45245 0.306456 16.3333C0.306456 19.0208 0.953384 21.714 2.25376 24.1006L0 32.5898L8.48118 30.3382C16.0705 34.664 25.747 32.0418 30.2339 24.5175C34.7834 16.8883 32.1896 7.03061 24.5739 2.48914L24.5677 2.4855C22.056 1.02032 19.2593 0.25 16.3898 0.25ZM1.80646 16.3333C1.80646 8.28088 8.33734 1.75 16.3898 1.75C18.9858 1.75 21.5213 2.44571 23.8088 3.77934C30.724 7.90536 33.0622 16.846 28.9456 23.7492C24.8204 30.6669 15.8781 33.0064 8.97392 28.8892L8.70263 28.7274L2.11291 30.4769L3.8603 23.8951L3.70764 23.6279C2.44262 21.4141 1.80646 18.8768 1.80646 16.3333ZM16.3898 21.5837C13.1374 21.5837 10.4731 18.9194 10.4731 15.667H8.97314C8.97314 19.7479 12.3089 23.0837 16.3898 23.0837C20.4707 23.0837 23.8065 19.7479 23.8065 15.667H22.3065C22.3065 18.9194 19.6423 21.5837 16.3898 21.5837Z",
  fill: "#2F7067"
});

var SvgMessage = function SvgMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message.984fc9c2.svg";
export { ForwardRef as ReactComponent };